import {
  ProductLaunch,
  COO,
  CFO,
  CRO,
  Pricing,
  Organic,
  Optimization,
  Overview,
  Intelligence,
} from "../../widgets";

export const tabsLabels = [
  "Product Launch",
  "coo",
  "cfo",
  "CRO",
  "pricing",
  "Organic Social",
  "Ad optimization",
  "Overview",
  "Market intelligence",
];

export const tabsComponents = [
  ProductLaunch,
  COO,
  CFO,
  CRO,
  Pricing,
  Organic,
  Optimization,
  Overview,
  Intelligence,
];
